import React from "react";

const SalesPageFooter = () => (
    <footer className="footer-sales-page py-3 mt-5">
        <div className="container px-5">
            <div className="d-flex align-items-center w-100 flex-wrap">
                {/* Copyright - left aligned, match header margin */}
                <div className="flex-shrink-0 d-flex align-items-center justify-content-start" style={{ width: "22%", minWidth: 140 }}>
                    <span className="fw-bold text-secondary text-start w-100" style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        © {new Date().getFullYear()} @ FRAYO
                    </span>
                </div>
                {/* Payment Card Icons - center aligned */}
                <div className="flex-grow-1 d-flex align-items-center justify-content-center" style={{ minWidth: 0 }}>
                    <img src="../../assets/images/icons8-visa-card.svg" alt="Visa" style={{ height: 32, marginRight: 8 }} />
                    <img src="../../assets/images/icons8-mastercard.svg" alt="Mastercard" style={{ height: 32, marginRight: 8 }} />
                    <img src="../../assets/images/icons8-american-express.svg" alt="American Express" style={{ height: 32 }} />
                </div>
                {/* Policy Links - right aligned, match header margin */}
                <div className="flex-shrink-0 d-flex align-items-center justify-content-end gap-3" style={{ width: "30%", minWidth: 140 }}>
                    <a href="https://www.frayo.net/terms-and-condition/" className="text-decoration-none text-secondary small" target="_blank" rel="noopener noreferrer">Terms & Conditions</a>
                    <a href="https://www.frayo.net/privacy-policy/" className="text-decoration-none text-secondary small" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                    <a href="https://www.frayo.net/refund-policy/" className="text-decoration-none text-secondary small" target="_blank" rel="noopener noreferrer">Refund Policy</a>
                </div>
            </div>
        </div>
    </footer>
);

export default SalesPageFooter;
